import React, { useCallback, useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import TextInput from '../../components/TextInput'
import { req } from '../../util'
export const Scan = () => {

    const history = useHistory()
    const [cars, setCars] = useState([])
    const [carID, setCarID] = useState("")


    const getCars = useCallback(async () => {
        let { success, data } = await req("GET", "car/img/ready")
        if (success && data.length > 0) setCars(data)
    }, [])


    const gotoCat = (evt) => {
        evt.preventDefault()
        history.push(`/sketch?id=${carID}`)
    }


    useEffect(() => {
        getCars()
    }, [getCars])

    return (
        <div className="container mx-auto p-4">
            <div className='text-center text-lg text-gray-800 font-semibold my-2'>
                العجلات الجهازة للفحص
            </div>
            <form action='?' onSubmit={gotoCat} className="flex justify-center items-center">
                <TextInput
                    value={carID}
                    onChange={evt => setCarID(evt.target.value)}
                    className="block h-8- py-2 text-gray-700 pr-2 bg-gray-200 rounded text-sm focus:outline-none focus:bg-white focus:border-gray-600 border leading-tight w-1/2 border-gray-300"
                    placeholder="اعادة فحص العجلة #"
                />
            </form>
            <div className="flex flex-wrap justify-center m-2">
                {cars.map(c => (
                    <Link key={c.id} to={{ pathname: `/sketch`, state: c }} className="text-center text-lg font-semibold shadow-md border border-blue-200 rounded-lg bg-gray-200 w-3/4 md:w-1/4 lg:w-1/4 m-2 py-2 select-none cursor-pointer">
                        <div className="text-xl text-blue-700 font-normal">الماركة {c.brand}</div>
                        <div className="text-blue-300">الموديل {c.model}</div>
                        <div className="text-blue-300">سنة الصنع {c.year}</div>
                        <div className="text-blue-300">اللوحة {c.plateNo} - {c.plateType}</div>
                    </Link>
                ))}
            </div>
            {cars.length <= 0 &&
                <div className="text-center font-normal text-xl m-4">لا توجد عجلات جاهزة للفحص</div>
            }
        </div>
    )
}